import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class PromotionTouchPointUserService {

constructor(private http: HttpClientService) { }

getTouchPoints() {
  return this.http.get('/koncentro-promo/touch-point')
}

getTouchPointUser() {
  return this.http.get('/koncentro-promo/touch-point/user')
}

createTouchPointUser(payload) {
  return this.http.post('/koncentro-promo/touch-point/user', payload);
}

editTouchPointUser(id: number, payload) {
  return this.http.put(`/koncentro-promo/touch-point/user/${id}`, payload);
}

deleteTouchPointUser(id: number) {
  return this.http.delete(`/koncentro-promo/touch-point/user/${id}`);
}

recoverTouchPointUser(id: number) {
  return this.http.put(`/koncentro-promo/touch-point/user/recover/${id}`, {});
}

}




// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-touch-point-user.service.ts